export default "__VITE_ASSET__rXzMMHAR__"